export const applicationSafetyCheck = async () => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/application/safety_check`,
    {
      credentials: "include",
      timeout: 10000
    },
  );

  return response;
};
